"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Twitter_svg_1 = __importDefault(require("./Twitter.svg"));
/**
 * Twitter icon.
 * figma link - https://www.figma.com/file/M9VCQnWUmAbbRy9VXOtlwO/Atomic-Icons?node-id=916%3A916
 */
function TwitterIcon() {
    return (0, jsx_runtime_1.jsx)(Twitter_svg_1.default, {});
}
exports.TwitterIcon = TwitterIcon;
//# sourceMappingURL=TwitterIcon.js.map